import axiosInstance from "../Interceptor"

export const getTopSellingProductApi = (payload) => {

	return (
		axiosInstance
			.get(`inventory/api/v1/top-selling-product/?page=${payload}`)
			 
			.then(function (response) {
				return response
			})
			.catch((error) => {
				 
				return error
			})
	)
}
